/** @desc AWS domain name */
export const AWS_DOMAIN = 'collegeplanning';

/** @desc Invalid clock error code */
export const INVALID_CLOCK_ERROR_CODE = 'InvalidSignatureException';

//***** Media Queries ***************************//
/** @desc Media Query: mobile */
export const XS = '(max-width: 767px)';
/** @desc Media Query: tablet */
export const SM = '(min-width: 768px) and (max-width: 1023px)';
/** @desc Media Query: desktop */
export const MD = '(min-width: 1024px) and (max-width: 1249px)';
/** @desc Media Query: high res */
export const LG = '(min-width: 1250px)';
/** @desc Media Query: mobile/tablet */
export const XS_SM = '(max-width: 1023px)';
/** @desc Media Query: tablet/desktop/high res */
export const SM_MD_LG = '(min-width: 768px)';
/** @desc Media Query: tablet/desktop */
export const SM_MD = '(min-width: 768px) and (max-width: 1249px)';
/** @desc Media Query: desktop/high res */
export const MD_LG = '(min-width: 1024px)';
//***********************************************//

//***** Page Titles *****************************//
/** @desc default organization title */
export const ORG_TITLE = 'The College Board';
/** @desc page title separator */
export const PAGE_TITLE_SEPARATOR = ' - ';

/** @desc id of main content section */
export const MAIN_CONTENT_ID = 'main-content';

/**
 * CB base url
 * @type {string}
 */
export const BASE_URL = window.location.origin;

/** @desc CB app id */
export const APP_ID = 435;
/** @desc session storage key for iam login redirect flag */
export const IAM_LOGIN_REDIRECT = 'IAM_LOGIN_REDIRECT';
/** @desc iam login url */
export const IAM_LOGIN_URL = `https://account.collegeboard.org/login/login?appId=${APP_ID}&DURL=${BASE_URL}/`;

export const alert_show = display_setting => {
  document.getElementById('glob_MessageModal').style.display = `${display_setting}`;
};
/**
 * users roles
 */
export const ADMIN_ROLE = '2016'; //461 -> 2016
export const SUBMITTER_ROLE = '2014'; //460 -> 2014
export const EDITOR_ROLE = '2015'; //470 -> 2015
export const EM_ROLE = '3611'; //EM_ROLE
export const BCFP_ROLES_ARR = [ADMIN_ROLE, SUBMITTER_ROLE, EDITOR_ROLE, EM_ROLE];
export const INVALID_ROLE = '-1000';
export const ERROR_TYPES = {
  SIMPLE: 'simple',
  COMPLEX: 'complex'
};
export const ROLE_TO_NAME = {
  [ADMIN_ROLE]: 'ADMIN',
  [SUBMITTER_ROLE]: 'SUBMITTER',
  [EDITOR_ROLE]: 'EDITOR',
  [EM_ROLE]: 'EM'
};

export const NOTAVAILABLE = 'N/A';
/**
 * Main CB APP config
*/
export const APP_CONFIG = {
  BASE_URL,
  PAGE_TITLE_SEPARATOR,
  MAIN_CONTENT_ID,
  ORG_TITLE,
  IAM_LOGIN_URL,
  alert_show
};
//    https://mycb-local.collegeplanning-nonprod.collegeboard.org:3000/organizations/83/categories/0
//    https://mycb-local.collegeplanning-nonprod.collegeboard.org:3000/modulepage/1

export const DATE_REGEX = {
  MM_DD_YYYY: /^\d{1,2}\/\d{1,2}\/\d{1,4}$/,
  MM_DD: /^\d{1,2}\/\d{1,2}$/
};